module.exports = __webpack_public_path__ + "img/pic-4.db182cfb.png";